import { useEffect, useState } from 'react';
import { useFormik } from 'formik';

import { initialValues, validationSchema } from './formData';
import { PqrTimesDataProps } from './props';

import { ParamEnum, ISelect } from '../../../../../../shared/types/shared';
import { PqrTimeDate } from '../../../../../../shared/types/paramPqrTimes';
import { asyncGetParams } from '../../../../../../services/param.service';

export const usePqrTimesData = ({
    data,
    onChangeData,
    onChangeFormik,
}: PqrTimesDataProps) => {
    const [typesClassification, setTypesClassification] = useState<ISelect[]>(
        []
    );

    const onSubmit = (data: PqrTimeDate) => {
        if (onChangeData) onChangeData(data || {});
    };

    const formik = useFormik({
        initialValues,
        validationSchema,
        onSubmit,
    });

    useEffect(() => {
        if (onChangeFormik) onChangeFormik(formik);
    }, [formik.values, formik.errors]);

    useEffect(() => {
        formik?.setFieldValue(
            'typeSacTime',
            (data?.typeSacTime as ISelect)?.id || ''
        );
        formik?.setFieldValue(
            'typeClassificationSacTime',
            (data?.typeClassificationSacTime as ISelect)?.id || ''
        );
        formik?.setFieldValue('sacTime', data?.sacTime?.toString() || '');

        formik?.setFieldValue('typeFuragTime', 'Normativa');
        formik?.setFieldValue(
            'typeClassificationFuragTime',
            (data?.typeClassificationFuragTime as ISelect)?.id || ''
        );
        formik?.setFieldValue('furagTime', data?.furagTime?.toString() || '');
    }, [data]);

    useEffect(() => {
        asyncGetParams(ParamEnum.ALERTS_CLASSIFICATION).then((params) =>
            setTypesClassification(params)
        );
    }, []);

    return {
        formik,
        typesClassification,
    };
};
